import { Avatar } from 'antd';

function ChatBox(props) {
  const time = new Date();

  return props.msg.sent ? (
    <div className="m-2">
      <div className="flex justify-end">
        <span className="rounded-2xl rounded-br-none bg-blue-500 p-3 text-white">
          {props.msg.msg}
        </span>
      </div>
      <div className="flex justify-end">
        <p className="m-2 text-xs text-slate-500">
          {time.toString().split(' ').slice(0, 4).join(' ')}
        </p>
      </div>
    </div>
  ) : (
    <div className="m-2 flex items-start gap-2">
      <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=3" size={40} />
      <div className="w-full">
        <p className="text-xs font-semibold text-blue-500">RDx Bot</p>
        <p className="w-3/5 rounded-2xl rounded-tl-none border border-slate-200 bg-white p-2 text-slate-800">
          {props.msg.msg}
        </p>
        <p className="m-2 text-xs text-slate-500">
          {time.toString().split(' ').slice(0, 4).join(' ')}
        </p>
      </div>
    </div>
  );
}

export default ChatBox;
